import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import auth from "./auth";
import isLoading from "./isLoading";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage/session";
import headers from "./headers";
import history from "../history";
const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    isLoading,
    headers,
    auth,
  });

const persistConfig = {
  key: "opr-webadmin",
  storage: storage,
  timeout: null,
  blacklist: ["router"],
};

const persistedReducer = (history) =>
  persistReducer(persistConfig, rootReducer(history));

export default persistedReducer;